import { createContext, useContext } from 'react';
import type { HelpContextId } from './contexts';

export interface HelpLayer {
  context: HelpContextId;
  /** The dialog's title, for "Help: New payout". */
  title: string;
}

export interface HelpApi {
  /** Opens help for a dialog context, or (no argument) for the top open dialog, else the page. */
  openHelp: (layer?: HelpLayer) => void;
  closeHelp: () => void;
  /** A dialog with help registers while it is open, so the "?" key opens its help. */
  pushLayer: (layer: HelpLayer) => () => void;
}

const noop: HelpApi = { openHelp: () => undefined, closeHelp: () => undefined, pushLayer: () => () => undefined };

export const HelpApiContext = createContext<HelpApi>(noop);

export const useHelp = () => useContext(HelpApiContext);
